import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { DefaultDTO, ErrorDTO } from '../../dto'
import { store } from '../../store'
import { BASE_ACTIONS, BASE_METHODS } from '../base/base.constants'
import { createCall } from '../base'
import { DELETE_WARRANTY_ACTIONS } from './warranties.constants'
import { getWarranties } from './get-warranties.action'

export const deleteWarranty = async (id: number, vin: string) => {
    store.dispatch({ type: DELETE_WARRANTY_ACTIONS.DELETE_WARRANTY_STARTED })

    const promise = createCall(`warranties/${id}`, true, BASE_METHODS.DELETE)
    promise
        .then(async (response) => {
            let body: DefaultDTO

            try {
                body = plainToClass(DefaultDTO, JSON.parse(await response.text()))
            } catch (exception) {
                store.dispatch({ type: BASE_ACTIONS.ERROR_INVALID_JSON })
                return
            }

            if ((await validate(body)).length > 0) {
                store.dispatch({ type: BASE_ACTIONS.ERROR_INVALID_RESPONSE })
                return
            }

            store.dispatch({ type: DELETE_WARRANTY_ACTIONS.DELETE_WARRANTY_OK })

            store.dispatch({ type: BASE_ACTIONS.CLEAR_ERROR })

            getWarranties(vin)
        })
        .catch(async (response) => {
            let error: ErrorDTO

            try {
                error = plainToClass(ErrorDTO, JSON.parse(await response.text()))
            } catch (exception) {
                //store.dispatch({ type: response })
                return
            }

            store.dispatch({ type: DELETE_WARRANTY_ACTIONS.DELETE_WARRANTY_FAILED })

            store.dispatch({ type: BASE_ACTIONS.ERROR_MESSAGE, message: error.message, code: error.code })
        })
}
